import React, { useCallback, useMemo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap-5';

import PersonForm from './person_form';
import CompanyForm from './company_form';
import { CONNECT_COMPANY_TYPE, CONNECT_PERSON_TYPE, type Contact, type ContactAddress, type ContactEmail, type ContactPhoneNumber } from 'bundles/connect/types';

type ContactFormProps = {
  initialContact?: Contact;
  type?: typeof CONNECT_PERSON_TYPE | typeof CONNECT_COMPANY_TYPE;
  onCancel: () => void;
  onSave: (data: {
    contact: {
      firstName?: string;
      lastName?: string;
      birthday?: string;
      type?: typeof CONNECT_PERSON_TYPE | typeof CONNECT_COMPANY_TYPE;
      addressesAttributes?: ContactAddress[];
      emailsAttributes?: ContactEmail[];
      phoneNumbersAttributes?: ContactPhoneNumber[];
    }
  }) => void;
}

export default function ContactForm({ initialContact = {} as Contact, onSave, onCancel, type }: ContactFormProps) {
  const [formData, setFormData] = useState({ ...initialContact, type });
  const [emails, setEmails] = useState(initialContact.emails || []);
  const [phoneNumbers, setPhoneNumbers] = useState(initialContact.phoneNumbers || []);
  const [addresses, setAddresses] = useState(initialContact.addresses || []);

  const handleSave = useCallback(() => {
    onSave({
      contact: {
        ...formData,
        type,
        emailsAttributes: emails,
        phoneNumbersAttributes: phoneNumbers,
        addressesAttributes: addresses
      }
    });
  }, [formData, emails, phoneNumbers, addresses, type]);

  const handleFormChange = useCallback((e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  }, [formData]);

  const FormComponent = useMemo(() => {
    if (type == CONNECT_PERSON_TYPE) return PersonForm;
    if (type == CONNECT_COMPANY_TYPE) return CompanyForm;
  }, [type]);

  return (
    <>
      <Modal.Body className="d-flex flex-column gap-3">
        {FormComponent && (
          <FormComponent
            addresses={addresses}
            emails={emails}
            formData={formData}
            phoneNumbers={phoneNumbers}
            onFormChange={handleFormChange}
            onSetAddresses={setAddresses}
            onSetEmails={setEmails}
            onSetPhoneNumbers={setPhoneNumbers}
          />
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end gap-2">
        <Button variant="outline-primary" onClick={onCancel}>Cancel</Button>
        <Button variant="secondary" onClick={handleSave}>Save</Button>
      </Modal.Footer>
    </>
  );
}
